import { render, staticRenderFns } from "./MilestoneEditPopup.vue?vue&type=template&id=1c20308d&scoped=true&"
import script from "./MilestoneEditPopup.vue?vue&type=script&lang=js&"
export * from "./MilestoneEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneEditPopup.vue?vue&type=style&index=0&id=1c20308d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20308d",
  null
  
)

export default component.exports